module.exports = __webpack_public_path__ + "static/media/UD.9025e81c.svg";